import React, { useEffect, useMemo } from 'react';
import { TableLobby } from '@pascal/pascal-core';
import gameLogo from '../../assets/images/turbo-blackjack/bacarat-logo.png';
import currentWinnersImg from '../../assets/images/turbo-blackjack/Baccarat-red-table.png';
import gray from '../../assets/images/lobby/gray.mp4';
import yellow from '../../assets/images/lobby/yellow.mp4';
import red from '../../assets/images/lobby/red.mp4';
import { soundService } from '../../services/SoundService';

export function TableLobbyWr() {
  const lobbyRoomImages = useMemo(
    () => ({
      red,
      yellow,
      gray,
    }),
    []
  );

  useEffect(() => {
    return soundService.stopAll();
  }, []);

  return (
    <TableLobby
      lobbyRoomImages={lobbyRoomImages}
      gameLogo={gameLogo}
      isShowGameTypeName={false}
      hasVideo
      currentWinnersImg={currentWinnersImg}
    />
  );
}
